




import { Component, Prop, Vue } from 'vue-property-decorator';
import EventCalendarEvent from '@/containers/pages/EventCalendarEvent.vue';

@Component({ components: { EventCalendarEvent } })
export default class EventCalendarEventReadOnly extends Vue {}
